module.exports = __webpack_public_path__ + "img/05.5c9b1386.png";